import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  HomeIcon,
  UserIcon,
  DocumentTextIcon,
  Squares2X2Icon,
  Cog6ToothIcon,
  ArrowLeftOnRectangleIcon
} from '@heroicons/react/24/outline'
import { useAuthStore } from '../../store/authStore'

function Sidebar() {
  const location = useLocation()
  const { user, logout } = useAuthStore()

  const isActive = (path) => location.pathname === path

  const menuItems = [
    { name: 'Dashboard', path: '/dashboard', icon: HomeIcon },
    { name: 'Mi Dkard', path: '/editor', icon: DocumentTextIcon },
    { name: 'Plantillas', path: '/templates', icon: Squares2X2Icon },
    { name: 'Perfil', path: '/settings', icon: UserIcon },
  ]

  const adminMenuItems = [
    { name: 'Panel Admin', path: '/admin', icon: HomeIcon },
    { name: 'Usuarios', path: '/admin/users', icon: UserIcon },
    { name: 'Plantillas', path: '/admin/templates', icon: Squares2X2Icon },
    { name: 'Métricas', path: '/admin/metrics', icon: Cog6ToothIcon },
  ]

  return (
    <div className="hidden md:flex md:w-64 md:flex-col bg-white shadow-lg">
      <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
        {/* User Info */}
        <div className="flex items-center flex-shrink-0 px-4 mb-8">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-r from-primary-500 to-accent-500 rounded-full flex items-center justify-center">
              <span className="text-white font-semibold text-sm">
                {String(user?.displayName || user?.email || '?').charAt(0).toUpperCase()}
              </span>
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">{user?.displayName}</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-2 space-y-1">
          {user?.role === 'admin' ? (
            adminMenuItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`${
                  isActive(item.path)
                    ? 'bg-primary-100 text-primary-900 border-r-2 border-primary-500'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                } group flex items-center px-2 py-2 text-sm font-medium rounded-l-md transition-colors duration-200`}
              >
                <item.icon
                  className={`${
                    isActive(item.path) ? 'text-primary-500' : 'text-gray-400 group-hover:text-gray-500'
                  } mr-3 flex-shrink-0 h-5 w-5`}
                />
                {item.name}
              </Link>
            ))
          ) : (
            menuItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`${
                  isActive(item.path)
                    ? 'bg-primary-100 text-primary-900 border-r-2 border-primary-500'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                } group flex items-center px-2 py-2 text-sm font-medium rounded-l-md transition-colors duration-200`}
              >
                <item.icon
                  className={`${
                    isActive(item.path) ? 'text-primary-500' : 'text-gray-400 group-hover:text-gray-500'
                  } mr-3 flex-shrink-0 h-5 w-5`}
                />
                {item.name}
              </Link>
            ))
          )}
        </nav>
      </div>

      {/* Logout */}
      <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
        <button
          onClick={logout}
          className="flex items-center space-x-3 text-gray-600 hover:text-gray-900 w-full px-2 py-2 text-sm font-medium rounded-md hover:bg-gray-50 transition-colors duration-200"
        >
          <ArrowLeftOnRectangleIcon className="mr-3 flex-shrink-0 h-5 w-5" />
          Cerrar sesión
        </button>
      </div>
    </div>
  )
}

export default Sidebar
